//ACTIONS

import fetch from 'isomorphic-fetch'

//import Notifications from 'react-notification-system-redux'; project hasn't been updated in 4 years. 
import Ajv from 'ajv';
import fetchInitSchema from '../schema/FetchInit.schema';
import ReactGA from 'react-ga'

export const SET_QUERY = 'SET_QUERY';
export const SET_SORT = 'SET_SORT';
export const SET_SORT_COURSES = 'SET_SORT_COURSES';
export const SET_PRUNE_TOPIC = 'SET_PRUNE_TOPIC';
export const SET_PRUNE_LANGUAGE = 'SET_PRUNE_LANGUAGE';
export const RECIEVE_TOPICS = 'RECIEVE_TOPICS';
export const RECIEVE_SEARCH = 'RECIEVE_SEARCH';
export const RECIEVE_SEARCH_LANGUAGE = 'RECIEVE_SEARCH_LANGUAGE';
export const RECIEVE_SEARCH_TOPICS = 'RECIEVE_SEARCH_TOPICS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';

export const SET_SERVER_OK = 'SET_SERVER_OK';
export const SHOW_ERROR_PAGE = 'SHOW_ERROR_PAGE';
export const SHOW_SCHEMA_ERROR = 'SHOW_SCHEMA_ERROR';

export const SET_USER_INITIALIZED = 'SET_USER_INITIALIZED';
export const SET_CATALOG_INITIALIZED = 'SET_CATALOG_INITIALIZED';
export const SET_LESSON_INITIALIZED = 'SET_LESSON_INITIALIZED';
export const SET_COURSE_INITIALIZED = 'SET_COURSE_INITIALIZED';

export const RECIEVE_MODULE = 'RECIEVE_MODULE';
export const RECEIVE_COURSE = 'RECEIVE_COURSE';
export const RECIEVE_USER_QUIZ = 'RECIEVE_USER_QUIZ';
export const RECIEVE_USER_SURVEY = 'RECIEVE_USER_SURVEY';
export const RECIEVE_USER_SURVEY_ETC = 'RECIEVE_USER_SURVEY_ETC';
export const RECIEVE_USER_FEEDBACK = 'RECIEVE_USER_FEEDBACK';
export const RECIEVE_USER_METADATA = 'RECIEVE_USER_METADATA';
export const RECIEVE_USER_COMPLETIONS = 'RECIEVE_USER_COMPLETIONS';

export const SET_REDIRECT_PAGE = 'SET_REDIRECT_PAGE';
export const ADD_SURVEY_RESPONSE = 'ADD_SURVEY_RESPONSE';
export const ADD_SURVEY_RESPONSE_TEXT = 'ADD_SURVEY_RESPONSE_TEXT';
export const ADD_SURVEY_STARS = 'ADD_SURVEY_STARS';

export const SET_METED_FEEDBACK_TAKEN = 'SET_METED_FEEDBACK_TAKEN';
export const ADD_METED_FEEDBACK_TEXT = 'ADD_METED_FEEDBACK_TEXT';
export const SET_FEEDBACK_ELIGIBILITY = 'SET_FEEDBACK_ELIGIBILITY';

export const SAVING_REVIEWS = 'SAVING_REVIEWS';
export const ADD_REVIEW = 'ADD_REVIEW';

export const EDIT_REVIEW_STARS = 'EDIT_REVIEW_STARS';

export const SUBMIT_REVIEW = 'SUBMIT_REVIEW';
export const SET_SURVEY_TAKEN = 'SET_SURVEY_TAKEN';

export const RECIEVE_REVIEWS = 'RECIEVE_REVIEWS';

export const SET_QUIZ_PAGE_KEYS = 'SET_QUIZ_PAGE_KEYS';
export const SET_QUIZ_PAGE = 'SET_QUIZ_PAGE';
export const CLEAR_QUIZ = 'CLEAR_QUIZ';
export const CLEAR_QUIZ_RESULTS = 'CLEAR_QUIZ_RESULTS';
export const SET_QUIZ_RESULTS = 'SET_QUIZ_RESULTS';
export const CLEAR_QUIZ_HADTOCLEAR = 'CLEAR_QUIZ_HADTOCLEAR';

export const EDIT_BOOSTER_FEEDBACK = 'EDIT_BOOSTER_FEEDBACK';
export const SUBMIT_BOOSTER_FEEDBACK = 'SUBMIT_BOOSTER_FEEDBACK';
export const ADD_FEEDBACK_TEXT = 'ADD_FEEDBACK_TEXT';
export const SET_QUIZ_ANSWER = 'SET_QUIZ_ANSWER';
export const SET_CHECKBOX_ANSWER = 'SET_CHECKBOX_ANSWER';
export const REMOVE_CHECKBOX_ANSWER = 'REMOVE_CHECKBOX_ANSWER';
export const SHOW_QUIZ_ANSWERS = 'SHOW_QUIZ_ANSWERS';
export const SET_BOOSTER_ANSWER = 'SET_BOOSTER_ANSWER';

export const SHARE_SCORE_RESULTS = 'SHARE_SCORE_RESULTS';

export const SET_QUIZ_RANDOMANSWERKEYS = 'SET_QUIZ_RANDOMANSWERKEYS';
export const SET_QUIZ_RANDOMKEYS = 'SET_QUIZ_RANDOMKEYS';

export const RECIEVE_LOGOUT = 'RECIEVE_LOGOUT';
export const RECIEVE_LOGIN = 'RECIEVE_LOGIN';
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS';
export const SET_QUEUE_STATUS = 'SET_QUEUE_STATUS';

export const SET_LOGIN_FEEDBACK = 'SET_LOGIN_FEEDBACK';

export const SET_SURVEY_PAGE = 'SET_SURVEY_PAGE';
export const SET_LOCALE = 'SET_LOCALE';

export const UNSUBSCRIBE_BOOSTER = 'UNSUBSCRIBE_BOOSTER';
export const SUBSCRIBE_BOOSTER = 'SUBSCRIBE_BOOSTER';

export const RECIEVE_VIEWER = 'RECIEVE_VIEWER';

export const START_MEDIA_DOWNLOAD = 'START_MEDIA_DOWNLOAD';
export const UPDATE_MEDIA_DOWNLOAD = 'UPDATE_MEDIA_DOWNLOAD';
//export const STOP_MEDIA_DOWNLOAD = 'STOP_MEDIA_DOWNLOAD';

export const SET_SPOTTER_CHECKBOX_STATUS = 'SET_SPOTTER_CHECKBOX_STATUS';
export const SET_SPOTTER_STATE = 'SET_SPOTTER_STATE';
export const SET_SPOTTER_COUNTY = 'SET_SPOTTER_COUNTY';
export const SET_SPOTTER_COUNTY_STATE = 'SET_SPOTTER_COUNTY_STATE';

/*export const INIT_LESSON_STRUCTURE = 'INIT_LESSON_STRUCTURE';
export const COMPLETED_PAGE = 'COMPLETED_PAGE';
export const COMPLETED_SECTION = 'COMPLETED_SECTION';*/

export const RESET_LESSON = 'RESET_LESSON';
export const RESET_COURSE = 'RESET_COURSE';
export const RESET_QUIZ = 'RESET_QUIZ';

export const SET_ETC_SURVEY_READY = 'SET_ETC_SURVEY_READY'; //not used
export const SET_ETC_SURVEY_DISMISSED = 'SET_ETC_SURVEY_DISMISSED'; //not used
export const ADD_SURVEY_ETC = 'ADD_SURVEY_ETC';


export function setSurveyETC(rating, dismissed) {
	return dispatch => {

		return fetch(`/education_training/data_v3.php?get=setSurveyETC&rating=${rating}&dismissed=${dismissed}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				if (json.status === 'success') {
					dispatch({ type: RECIEVE_USER_SURVEY_ETC, json: json });
				}

			})
	}
}


export function setSpotterState(state) {
	return dispatch => {
		dispatch({ type: SET_SPOTTER_STATE, state: state });
		dispatch({ type: SET_SPOTTER_COUNTY, county: null });
		dispatch({ type: SET_SPOTTER_COUNTY_STATE, state: 0 });
	}
}


export function setSpotterCounty(county) {
	return dispatch => {

		dispatch({ type: SET_SPOTTER_COUNTY, county: county });
		dispatch({ type: SET_SPOTTER_COUNTY_STATE, state: 1 });

		return fetch(`/education_training/data_v3.php?get=setSpotterCounty&county=${county}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				if (json.status === 'success') {
					dispatch({ type: RECIEVE_USER_METADATA, userMetadata: json.userMetadata });
				}

				dispatch({ type: SET_SPOTTER_COUNTY_STATE, state: 2 });
			})
	}

}

export function setSpotter(bool) {
	return dispatch => {

		dispatch({ type: SET_SPOTTER_CHECKBOX_STATUS, isLoading: true });

		return fetch(`/education_training/data_v3.php?get=setSpotter&spotter=${bool}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				if (json.status === 'success') {
					dispatch({ type: RECIEVE_USER_METADATA, userMetadata: json.userMetadata });
				}

				dispatch({ type: SET_SPOTTER_CHECKBOX_STATUS, isLoading: false });
			})
	}
}


export function addToQueue(module_id) {
	return dispatch => {

		dispatch({ type: SET_QUEUE_STATUS, isLoading: true });

		return fetch(`/education_training/data_v3.php?get=enrollLesson&id=${module_id}`, { credentials: 'include' })
			.then(handleErrors)
			.then(response => response.json())
			.then(function (json) {
				if (json.status === 'success') {
					dispatch({ type: RECIEVE_USER_COMPLETIONS, userCompletions: json.userCompletions });
				}
				dispatch({ type: SET_QUEUE_STATUS, isLoading: false });
			})
			.catch(error => {
				dispatch({ type: SHOW_ERROR_PAGE, error: error });
			});

	}

}

export function removeFromQueue(module_id) {
	return dispatch => {

		dispatch({ type: SET_QUEUE_STATUS, isLoading: true });

		return fetch(`/education_training/data_v3.php?get=unenrollLesson&id=${module_id}`, { credentials: 'include' })
			.then(handleErrors)
			.then(response => response.json())
			.then(function (json) {
				if (json.status === 'success') {
					dispatch({ type: RECIEVE_USER_COMPLETIONS, userCompletions: json.userCompletions });
				}
				dispatch({ type: SET_QUEUE_STATUS, isLoading: false });
			})
			.catch(error => {
				dispatch({ type: SHOW_ERROR_PAGE, error: error });
			});
	}
}


export function downloadMediaItems(course_id, module_id, outline_id) {
	return dispatch => {
		navigator.sendBeacon(`/education_training/getMediaZip.php?type=courseMedia&state=start&courseID=${course_id}&moduleID=${module_id}&outlineID=${outline_id}`, { credentials: 'include' });

		//Maybe don't need a setInterval/ maybe just launch recursivley. 
		//let timer = setInterval( (course_id, module_id) => dispatch(updateMediaItemsStatus(course_id, module_id)),  300, course_id, module_id);
		dispatch(updateMediaItemsStatus(course_id, module_id, outline_id));

		dispatch({ type: UPDATE_MEDIA_DOWNLOAD, id: course_id + "_" + module_id, progress: 0, status: "Starting.." });
	}
}

const updateMediaItemsStatus = (course_id, module_id, outline_id) => {
	return dispatch => {
		return fetch(`/education_training/getMediaZip.php?type=courseMedia&state=progress&courseID=${course_id}&moduleID=${module_id}&outlineID=${outline_id}`, { credentials: 'include' })
			.then(handleErrors)
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: UPDATE_MEDIA_DOWNLOAD, id: course_id + "_" + module_id, progress: json.progress, status: json.status, error: json.error });

				if (json.progress === "100") {
					//dispatch({ type: STOP_MEDIA_DOWNLOAD, id: course_id + "_" + module_id, });

					window.location = `/education_training/getMediaZip.php?type=courseMedia&state=retrieve&courseID=${course_id}&moduleID=${module_id}&outlineID=${outline_id}`;
				} else {
					dispatch(updateMediaItemsStatus(course_id, module_id, outline_id));
				}

			})
			.catch(error => {
				dispatch({ type: SHOW_ERROR_PAGE, error: error });
			});

	}
};

/*
const stop = () => { 
	clearInterval(timer);
	return { type: TIMER_STOP };
}
*/

export function clearFilters() {
	return dispatch => {
		dispatch({ type: CLEAR_FILTERS });
	}
}

export function enrollCourse(id) {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=enrollCourse&id=${id}`, { credentials: 'include' })
			.then(handleErrors)
			.then(response => response.json())
			.then(function (json) {
				if (json.status === 'success') {
					dispatch({ type: RECIEVE_USER_COMPLETIONS, userCompletions: json.userCompletions });
				}
			})
			.catch(error => {
				dispatch({ type: SHOW_ERROR_PAGE, error: error });
			});

	}
}

export function unenrollCourse(id) {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=unenrollCourse&id=${id}`, { credentials: 'include' })
			.then(handleErrors)
			.then(response => response.json())
			.then(function (json) {
				if (json.status === 'success') {
					dispatch({ type: RECIEVE_USER_COMPLETIONS, userCompletions: json.userCompletions });
				}
			})
			.catch(error => {
				dispatch({ type: SHOW_ERROR_PAGE, error: error });
			});

	}
}

export function getCourse(id) {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=course&id=${id}`, { credentials: 'include' })
			.then(handleErrors)
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: RECEIVE_COURSE, json: json });
				//dispatch({ type: RECIEVE_SEARCH_LANGUAGE, json: json });
				//dispatch({ type: RECIEVE_SEARCH_TOPICS, json: json });
				dispatch({ type: RECIEVE_USER_METADATA, userMetadata: json.userMetadata });
				dispatch({ type: RECIEVE_USER_COMPLETIONS, userCompletions: json.userCompletions });
				dispatch({ type: SET_USER_INITIALIZED, bool: true });
				dispatch({ type: SET_COURSE_INITIALIZED, id: parseInt(json.course.data.id, 10) });
			})
			.catch(error => {
				dispatch({ type: SHOW_ERROR_PAGE, error: error });
			});

	}
}

export function resetCourse() {
	return dispatch => {
		dispatch({ type: RESET_COURSE });
	}
}

/*
export function getInteractions() {
	return new Promise(function (resolve, reject) {
		var connection = mysql.createConnection({
			host: '35.188.104.137',
			user: 'cloudUser',
			password: 'pwd4Cl0udUs3r',
			database: 'lesson_cloud'
		});

		connection.connect();
		connection.query('SELECT * FROM `lesson_viewer_interactions` ORDER BY version ASC, type ASC ', function (error, results, fields) {
			if (error) {
				console.log("db error: ", error);
				return reject(error);
			}
			resolve(results);
		});
	});
}
*/

export function setQuery(query) {
	return dispatch => {
		dispatch({ type: SET_QUERY, query: query });
	}
}


export function setSort(sort) {
	return dispatch => {
		dispatch({ type: SET_SORT, sort: sort });
	}
}

export function setSortCourses(sort) {
	return dispatch => {
		dispatch({ type: SET_SORT_COURSES, sort: sort });
	}
}

export function setTopicPrune(meta_id) {
	return dispatch => {
		dispatch({ type: SET_PRUNE_TOPIC, meta_id: meta_id });
	}
}

export function setLanguagePrune(id) {
	return dispatch => {
		dispatch({ type: SET_PRUNE_LANGUAGE, id: id });
	}
}

export function getCatalog() {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=catalog`, { credentials: 'include' })
			.then(handleErrors)
			.then(response => response.json())
			.then(function (json) {
				//dispatch({ type: RECIEVE_SEARCH, json: json }); //DISABLE FOR V1-METED 2025
				dispatch({ type: RECIEVE_USER_METADATA, userMetadata: json.userMetadata });
				//dispatch({ type: RECIEVE_USER_COMPLETIONS, userCompletions: json.userCompletions });
				dispatch({ type: SET_USER_INITIALIZED, bool: true });
				dispatch({ type: SET_CATALOG_INITIALIZED, bool: true }); //DISABLE FOR V1-METED 2025
			})
			.catch(error => {
				dispatch({ type: SHOW_ERROR_PAGE, error: error });
			});

	}
}
//v2 getLesson WITHOUT being logged in
export function getLesson(id) {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=lesson&id=${id}`, { credentials: 'include' })
			.then(handleErrors)
			.then(response => response.json())
			.then(function (json) {
				//console.log(json);
				dispatch({ type: SET_LESSON_INITIALIZED, id: parseInt(json.module.metadata.id, 10) });
				dispatch({ type: RECIEVE_MODULE, json: json.module });
				dispatch({ type: SET_USER_INITIALIZED, bool: true });
				//dispatch({ type: SET_CATALOG_INITIALIZED, bool: true });
			})
			.catch(error => {
				dispatch({ type: SHOW_ERROR_PAGE, error: error });
			});
	}
}
//v2 getFullLesson REQUIRES being logged in
export function getFullLesson(id) {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=init&id=${id}`, { credentials: 'include' })
			.then(handleErrors)
			.then(response => response.json())
			.then(function (json) {
				//console.log(json)
				var ajv = new Ajv(); // options can be passed, e.g. {allErrors: true}
				var validate = ajv.compile(fetchInitSchema);
				validate(json);
				if (validate.errors != null) {
					let error = { errors: validate.errors, json: json }
					dispatch({ type: SHOW_SCHEMA_ERROR, error: error });
				} else {
					//Success if the user is logged in. Right now this is the only reason init would fail...
					if (json.status === 'success') {
						dispatch({ type: RECIEVE_MODULE, json: json.module });
						dispatch({ type: RECIEVE_USER_QUIZ, json: json });
						dispatch({ type: RECIEVE_USER_SURVEY, json: json });
						dispatch({ type: RECIEVE_USER_SURVEY_ETC, json: json });
						dispatch({ type: RECIEVE_USER_FEEDBACK, json: json });
						dispatch({ type: RECIEVE_VIEWER, json: json.viewer });
						dispatch({ type: RECIEVE_USER_METADATA, userMetadata: json.user.metadata });
						dispatch({ type: SET_LESSON_INITIALIZED, id: parseInt(json.module.metadata.id, 10) });
						//dispatch({ type: SET_CATALOG_INITIALIZED, bool: true });
						dispatch({ type: RECIEVE_USER_COMPLETIONS, userCompletions: json.userCompletions });
						dispatch({ type: RECIEVE_SEARCH_TOPICS, json: json });
					}
					else {
						getLesson(id)(dispatch);  //curry dispatch
					}
					dispatch({ type: SET_USER_INITIALIZED, bool: true });
				}
			})
			.catch(error => {
				//dispatch({ type: SHOW_ERROR_PAGE, error: error });
				console.log(error);
			});
	}
}

export function resetLesson() {
	return dispatch => {
		dispatch({ type: RESET_LESSON });
		dispatch({ type: SET_LESSON_INITIALIZED, id: null });
	};
}

export function resetQuiz() {
	return dispatch => {
		dispatch({ type: RESET_QUIZ });
	};
}
/*
export function getDownloadStatus(id) {
	return dispatch => {
		return fetch(`/getZip.php?moduleID=${id}&type=lessonViewer&state=progress"`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: START_MEDIA_DOWNLOAD });
			})
	}
}
*/

export function clearAll(id) {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=clear&id=${id}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: RECIEVE_LOGOUT });
			})
	}
}

export function fastForwardBooster(id) {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=skipBoosterQuestion&id=${id}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: RECIEVE_LOGOUT });
			})
	}
}

export function saveBoosterAnswers(id, quiz_type, answers) {
	return dispatch => {

		//First update the ui so there is no UI lag.
		dispatch({ type: SHOW_QUIZ_ANSWERS, quiz_type: quiz_type });

		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=setBoosterAnswers&id=${id}&answers=${JSON.stringify(answers)}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: SET_SERVER_OK, json: json });
			})

	}
}

export function saveBoosterFeedback(id, quiz_type, user, feedback) {
	return dispatch => {

		//First update the ui so there is no UI lag.
		dispatch({ type: EDIT_BOOSTER_FEEDBACK, quiz_type: quiz_type, user: user });
		dispatch({ type: SHOW_QUIZ_ANSWERS, quiz_type: quiz_type });

		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=setBoosterFeedback&id=${id}&feedback=${feedback}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: SET_SERVER_OK, json: json });
			})

	}
}

export function submitBoosterFeedback(id, quiz_type, user, feedback) {
	return dispatch => {

		//First update the ui so there is no UI lag.
		dispatch({ type: SUBMIT_BOOSTER_FEEDBACK, quiz_type: quiz_type, user: user });


		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=setBoosterFeedback&id=${id}&feedback=${feedback}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: SET_SERVER_OK, json: json });
			})
	}
}

export function subscribeBooster(id) {
	return dispatch => {

		dispatch({ type: SUBSCRIBE_BOOSTER, id: id });

		return fetch(`/education_training/data_v3.php?get=subscribeBooster&id=${id}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				//Success if the user is logged in. Right now this is the only reason init would fail...
				if (json.status === 'success') {
					dispatch({ type: RECIEVE_USER_QUIZ, json: json });
				}
			})
	}
}

export function unsubscribeBooster(id) {
	return dispatch => {

		dispatch({ type: UNSUBSCRIBE_BOOSTER, id: id });

		return fetch(`/education_training/data_v3.php?get=unsubscribeBooster&id=${id}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				//Success if the user is logged in. Right now this is the only reason init would fail...
				if (json.status === 'success') {

					dispatch({ type: RECIEVE_USER_QUIZ, json: json });
				}
			})
	}
}

export function setLocale(locale) {
	return dispatch => {

		//First update the ui so there is no UI lag.
		dispatch({ type: SET_LOCALE, locale: locale });

		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=setLocale&locale=${locale}`, { credentials: 'include' })
			.then(response => response.json())
			.catch(error => console.log('Perhaps unable to store user language preference:', error))
			.then(function (json) {
				dispatch({ type: SET_SERVER_OK, json: json });
			})
	}
}

export function submitReview(id, review, stars) {
	return dispatch => {

		dispatch({ type: SAVING_REVIEWS });

		ReactGA.event({
			category: 'User',
			action: 'Review Submitted'
		});

		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=insertReview&module_id=${id}&stars=${stars}&review=${review}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: RECIEVE_REVIEWS, json: json });
			})
	}
}

export function saveReview(module_id, review_id, review, stars) {
	return dispatch => {

		dispatch({ type: SAVING_REVIEWS });

		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=updateReview&module_id=${module_id}&review_id=${review_id}&stars=${stars}&review=${review}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: RECIEVE_REVIEWS, json: json });
			})
	}
}

export function deleteReview(module_id, review_id) {
	return dispatch => {

		dispatch({ type: SAVING_REVIEWS });

		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=deleteReview&module_id=${module_id}&review_id=${review_id}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: RECIEVE_REVIEWS, json: json });
			})
	}
}

export function getReviews(id) {
	return dispatch => {

		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=getReviews&id=${id}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				if (json.status === 'success') {
					dispatch({ type: RECIEVE_REVIEWS, json: json });
				}
			})
	}
}

export function submitSurvey(id, stars, responses) {
	return dispatch => {

		//First update the ui so there is no UI lag.
		dispatch({ type: SET_SURVEY_TAKEN, bool: true });

		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=setSurveyResults&id=${id}&stars=${stars}&responses=${JSON.stringify(responses)}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: SET_SERVER_OK, json: json });
			})
	}

}

export function submitMetEdFeedback(id, responses) {
	return dispatch => {

		//First update the ui so there is no UI lag.
		dispatch({ type: SET_METED_FEEDBACK_TAKEN, bool: true });
		dispatch({ type: SET_SURVEY_TAKEN, bool: true });

		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=setMetEdFeedbackForSurvey&id=${id}&responses=${JSON.stringify(responses)}`, { credentials: 'include' })
			.then(response => response.json())
			.catch(error => console.log('Perhaps unable to store feedback:', error))
			.then(function (json) {
				dispatch({ type: SET_SERVER_OK, json: json });
			})
	}

}

export function addMetEdFeedbackText(qn, q, a) {
	return { type: ADD_METED_FEEDBACK_TEXT, qn: qn, q: q, a: a };
}

export function setFeedbackEligibility(bool) {
	return { type: SET_FEEDBACK_ELIGIBILITY, bool: bool };
}

export function setSurveyTaken(bool) {
	return { type: SET_SURVEY_TAKEN, bool: bool };
}


export function addReview(review, stars) {
	return { type: ADD_REVIEW, review: review, stars: stars };
}


export function addSurveyResponse(qn, q, a) {
	return { type: ADD_SURVEY_RESPONSE, qn: qn, q: q, a: a };
}

export function addSurveyResponseText(qn, text) {
	return { type: ADD_SURVEY_RESPONSE_TEXT, qn: qn, text: text };
}


export function editReviewStars(stars, id) {
	return { type: EDIT_REVIEW_STARS, stars: stars, id: id };
}

export function addSurveyStars(stars) {
	return { type: ADD_SURVEY_STARS, stars: stars };
}

//ETC Survey Question
export function addSurveyETC(lessonId, rating) {
	return { type: ADD_SURVEY_ETC, lessonId, rating };
}

function handleErrors(response) {
	if (!response.ok) {
		let e = Error(response.statusText + " " + response.status);
		e.name = "ResponseError";
		throw e;
	}
	return response;
}

export function init(id) {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=init&id=${id}`, { credentials: 'include' })
			.then(handleErrors)
			.then(response => response.json())
			.then(function (json) {
				var ajv = new Ajv(); // options can be passed, e.g. {allErrors: true}
				var validate = ajv.compile(fetchInitSchema);
				validate(json);
				if (validate.errors != null) {
					let error = { errors: validate.errors, json: json }
					dispatch({ type: SHOW_SCHEMA_ERROR, error: error });
				} else {
					//Success if the user is logged in. Right now this is the only reason init would fail...
					if (json.status === 'success') {
						dispatch({ type: RECIEVE_MODULE, json: json.module });
						dispatch({ type: RECIEVE_USER_QUIZ, json: json });
						dispatch({ type: RECIEVE_USER_SURVEY, json: json });
						dispatch({ type: RECIEVE_USER_SURVEY_ETC, json: json });
						dispatch({ type: RECIEVE_USER_FEEDBACK, json: json });
						dispatch({ type: RECIEVE_VIEWER, json: json.viewer });
						dispatch({ type: RECIEVE_USER_METADATA, userMetadata: json.user.metadata });
						dispatch({ type: SET_LESSON_INITIALIZED, id: parseInt(json.module.metadata.id, 10) });
						dispatch({ type: RECIEVE_USER_COMPLETIONS, userCompletions: json.userCompletions });
						dispatch({ type: RECIEVE_SEARCH_TOPICS, json: json });

					}
					dispatch({ type: SET_USER_INITIALIZED, bool: true });


				}

			})
			.catch(error => {
				dispatch({ type: SHOW_ERROR_PAGE, error: error });
			});
	}
}


export function logout() {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=logout`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				if(json.error === 'none') {
					dispatch({ type: RECIEVE_LOGOUT });
				}
			})
			.catch(error => {
				console.log('Something went wrong on logout! : ', error);
			});
	}
}


export function login(user, password, message) {

	return dispatch => {

		dispatch({ type: SET_LOGIN_STATUS, isLoading: true });


		return fetch(`/education_training/data_v3.php?get=login&user=${user}&password=${password}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				if (json.status === 'success') {
					dispatch({ type: RECIEVE_USER_METADATA, userMetadata: json.userMetadata });

					/*
					const notificationOpts = {
						//uid: 'once-please', // you can specify your own uid if required 
						message,
						autoDismiss: 3,
					};
					*/

					//dispatch(Notifications.success(notificationOpts));
				}

				dispatch({ type: SET_LOGIN_FEEDBACK, feedback: json.error });
				dispatch({ type: SET_LOGIN_STATUS, isLoading: false });
			})
	}
}

export function hadToClearNotification(notificationOpts, quiz_id) {
	return dispatch => {
		dispatch({ type: CLEAR_QUIZ_HADTOCLEAR, quiz_id: quiz_id });
		//dispatch(Notifications.info(notificationOpts));
	}
}

export function setRedirectPage(page) {
	return { type: SET_REDIRECT_PAGE, page: page };
}

export function setLoginFeedback(feedback) {
	return { type: SET_LOGIN_FEEDBACK, feedback: feedback };
}


export function setQuizPage(quiz_type, quiz_id, page, answers, random_keys) {
	return dispatch => {

		//First update the ui so there is no UI lag.
		dispatch({ type: SET_QUIZ_PAGE, quiz_type: quiz_type, page: page });

		//Then async store the data, if there is an error let the user know.  
		return fetch(`/education_training/data_v3.php?get=setQuizPage&quiz_id=${quiz_id}&page=${page}&answers=${JSON.stringify(answers)}&random_keys=${JSON.stringify(random_keys)}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: SET_SERVER_OK, json: json });
			})
	}
}


export function addFeedbackText(quiz_type, text) {
	return { type: ADD_FEEDBACK_TEXT, quiz_type: quiz_type, text: text };
}



export function setQuizAnswers(quiz_type, question_type, qn, an, a) {
	return { type: SET_QUIZ_ANSWER, quiz_type: quiz_type, question_type: question_type, qn: qn, an: an, a: a };
}

export function addCheckboxAnswer(quiz_type, qn, an, a) {
	return { type: SET_CHECKBOX_ANSWER, quiz_type: quiz_type, qn: qn, an: an, a: a };
}

export function removeCheckboxAnswer(quiz_type, qn, an, a) {
	return { type: REMOVE_CHECKBOX_ANSWER, quiz_type: quiz_type, qn: qn, an: an, a: a };
}


export function clearQuiz(quizTemplate, quiz_type) {
	return { type: CLEAR_QUIZ, quizTemplate: quizTemplate, quiz_type: quiz_type };
}

export function setQuizResults(quiz_id, answers, randomKeys) {

	console.log("setQuizResults", quiz_id, answers, randomKeys);
	console.log(`/education_training/data_v3.php?get=setQuizResults&quiz_id=${quiz_id}&answers=${JSON.stringify(answers)}&random_keys=${JSON.stringify(randomKeys)}`)
	return dispatch => {

		//First update the ui so there is no UI lag.
		dispatch({ type: CLEAR_QUIZ_RESULTS, quiz_id: quiz_id });

		return fetch(`/education_training/data_v3.php?get=setQuizResults&quiz_id=${quiz_id}&answers=${JSON.stringify(answers)}&random_keys=${JSON.stringify(randomKeys)}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				console.log(json)
				dispatch({ type: SET_QUIZ_RESULTS, results: json, quiz_id: json.quiz_id });
			})
	}
}

export function shareScore(quiz_id, email, locale) {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=setShareScore&quiz_id=${quiz_id}&email=${email}&locale=${locale}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: SHARE_SCORE_RESULTS, json: json });
			})
	}
}

// LESSON COMPLETION ACTIONS
/*export function initLessonMenu(menu){
	return dispatch => {
		dispatch({ type: INIT_LESSON_STRUCTURE, data: menu});
	}
}*/

// ETC SURVEY ACTIONS
export function setETCSurveyPopupReady(lessonId, userId, status) {
	return dispatch => {
		dispatch({ type: SET_ETC_SURVEY_READY });
	}
}

export function setETCSurveyPopupDismissed(dismissed) {
	return dispatch => {
		return fetch(`/education_training/data_v3.php?get=setSurveyETC&rating=1&dismissed=${dismissed}`, { credentials: 'include' })
			.then(response => response.json())
			.then(function (json) {
				dispatch({ type: SET_ETC_SURVEY_DISMISSED });
			})
	}
}